<script setup lang="ts">
import { type HTMLAttributes, computed } from 'vue'
import { cn } from "@/lib/utils";
import { DropdownMenuTrigger, type DropdownMenuTriggerProps, useForwardProps } from "radix-vue";
import { buttonVariants } from "../button";

const props = defineProps<DropdownMenuTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <DropdownMenuTrigger
    class="outline-none"
    v-bind="forwardedProps"
    :class="cn(buttonVariants({ variant: 'ghost' }), props.class, 'data-[state=open]:bg-gray-100')"
  >
    <slot />
  </DropdownMenuTrigger>
</template>
